/**
 * @desc 分页条件查询spu列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlmSpuListResponseDto>
>;
export function request(
  body: defs.basics.PlmSpuRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/spu/page`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
